import { GroupProps, components as ReactSelectComponents, GroupBase, SelectComponentsConfig } from 'react-select';

import groupedStyles from '../groupedSelect.module.scss';

interface IProps<SOption, IsMulti extends boolean, Group extends GroupBase<SOption>> {
  dataTest: string,
  components?: SelectComponentsConfig<SOption, IsMulti, Group>,
  ownProps: GroupProps<SOption, IsMulti, Group>,
}

const Group = <SOption, IsMulti extends boolean, Group extends GroupBase<SOption>>({
  dataTest,
  components,
  ownProps: { children, ...otherProps },
}: IProps<SOption, IsMulti, Group>) => {
  const dataTestAttr = `${ dataTest }Group`;

  if (components?.Group) {
    const { Group: GroupComponents } = components;

    return (
      <div data-test={ dataTestAttr }>
        <GroupComponents { ...otherProps }>{ children }</GroupComponents>
      </div>
    );
  }

  return (
    <div data-test={ dataTestAttr }>
      <ReactSelectComponents.Group { ...otherProps } className={ groupedStyles.group }>
        { children }
      </ReactSelectComponents.Group>
    </div>
  );
};

export default Group;
